import React from "react"
import { get } from "lodash"
import RichText from "./RichText"
import styled from "@emotion/styled"
import tw from "twin.macro"

const Container = styled.div`
  max-width: 900px;
  ${tw`mx-auto`}
`

const TextBlock = ({ block, contrastText }) => {
  const text = get(block, "elements.text.value")
  const alignText = get(block, "elements.align_text.value[0].codename")
  const linkedItems = get(block, "elements.text.modular_content")
  const links = get(block, "elements.text.links")

  return (
    <Container>
      <RichText
        alignText={alignText}
        contrastText={contrastText}
        linkedItems={linkedItems}
        links={links}
      >
        {text}
      </RichText>
    </Container>
  )
}

export default TextBlock
